import React from 'react';

import LocationStore from '../../stores/LocationStore';
import LocationActions from '../../actions/LocationActionCreator';
import { LocationStatusStore, LocationTypeStore } from '../../stores/LocationLookupStore';
import { LocationStatusActions, LocationTypeActions } from '../../actions/LocationLookupActionCreator';

import CountryStore from '../../stores/CountryStore';
import CountryActions from '../../actions/CountryActionCreator';

import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import { Card, CardText } from 'material-ui/Card';

import MenuItem from 'material-ui/MenuItem';

const url = '/dashboard/locations';

const Location = React.createClass({

    getInitialState: function() {
        const locationId = Number(this.props.routeParams.id) || null;

        return {

            isEdit: !!locationId,
            locationId,
            venueId: Number(this.props.routeParams.venueId) || null,

            details: {
                id: '',
                name: '',
                capacity: '',
                description: '',
                type: 'standard',
                status: 'available',
                address1: '',
                address2: '',
                address3: '',
                city: '',
                countryId: '',
                latitude: '',
                longitude: '',
                postalCode: '',
                state: ''
            },
            types: [],
            statuses: [],
            countries: []
        };
    },

    componentDidMount: function() {

        this.listeners = [
            LocationStore.addListener(this.onLocationChange),
            LocationTypeStore.addListener(this.onLocationTypeChange),
            LocationStatusStore.addListener(this.onLocationStatusChange),
            CountryStore.addListener(this.onCountriesChange),
        ];
        if(this.state.isEdit) {
            LocationActions.getById(this.state.locationId);
        }
        LocationTypeActions.getAll();
        LocationStatusActions.getAll();
        CountryActions.getAll();
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove() );
    },

    render: function() {

        const formTitle  = (!this.state.isEdit ? 'New location' : this.state.details.name);
        const redirectTo = (this.state.isEdit ? '/dashboard/location/' + this.state.details.id : url);

        return (

            <Form
                title={formTitle}
                onSave={this.onSave}
                redirectTo={redirectTo}
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations="minLength:2,maxLength:255"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="Name"
                            hintText="Name"
                            required
                        />
                        <TextField
                            name="description"
                            value={this.state.details.description}
                            multiLine={true}
                            validations="minLength:2,maxLength:255"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="Description"
                            hintText="Description"
                        />
                        <TextField
                            name="address1"
                            value={this.state.details.address1}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="Address Line 1"
                            hintText="Address Line 1"
                            required={true}
                        />
                        <TextField
                            name="address2"
                            value={this.state.details.address2}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="Address Line 2"
                            hintText="Address Line 2"
                        />
                        <TextField
                            name="address3"
                            value={this.state.details.address3}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only numbers and letters, at least 2"
                            floatingLabelText="Address Line 3"
                            hintText="Address Line 3"
                        />
                        <div className='cent-flex-row'>
                            <div className='cent-col-2'>
                                <TextField
                                    name="city"
                                    value={this.state.details.city}
                                    validations="minLength:2,maxLength:120"
                                    validationError="Please use only numbers and letters, at least 2"
                                    floatingLabelText="City"
                                    hintText="City"
                                />
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="state"
                                    value={this.state.details.state}
                                    validations="minLength:2,maxLength:120"
                                    validationError="Please use only numbers and letters, at least 2"
                                    floatingLabelText="State"
                                    hintText="State"
                                />
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="postalCode"
                                    value={this.state.details.postalCode}
                                    validations="minLength:2,maxLength:12"
                                    validationError="Please use only numbers and letters, at least 2"
                                    floatingLabelText="PostalCode"
                                    hintText="PostalCode"
                                />
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="countryId"
                                    value={this.state.details.countryId}
                                    floatingLabelText="Country"
                                    hintText="Country"
                                    autoWidth={true}
                                    required={true}
                                >
                                    <MenuItem key={0} value={0} primaryText="Select" />
                                    {this.state.countries.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name}/>)}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="latitude"
                                    value={this.state.details.latitude}
                                    validations="minLength:2,maxLength:20"
                                    validationError="Please use only numbers and letters, at least 2"
                                    floatingLabelText="latitude"
                                    hintText="latitude"
                                />
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="longitude"
                                    value={this.state.details.longitude}
                                    validations="minLength:2,maxLength:20"
                                    validationError="Please use only numbers and letters, at least 2"
                                    floatingLabelText="longitude"
                                    hintText="longitude"
                                />
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="capacity"
                                    value={this.state.details.capacity}
                                    validations="isNumeric"
                                    validationError="Please use only numbers"
                                    hintText="Capacity"
                                    floatingLabelText="Capacity"
                                />
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="status"
                                    value={this.state.details.status}
                                    floatingLabelText="Status"
                                    hintText="Status"
                                    autoWidth={true}
                                    required
                                >
                                    {this.state.statuses.map(({id, name}) => (<MenuItem key={id} value={name} primaryText={name} />))}
                                </SelectField>
                            </div>
                            <div className='cent-col-1'>
                                <SelectField
                                    name="type"
                                    value={this.state.details.type}
                                    floatingLabelText="Type"
                                    hintText="Type"
                                    autoWidth={true}
                                    required
                                >
                                    {this.state.types.map(({id, name}) => (<MenuItem key={id} value={name} primaryText={name} />))}
                                </SelectField>
                            </div>
                        </div>
                    </CardText>
                </Card>
            </Form>
        )
    },

    onSave: function (model) {
        if (!!this.state.venueId) {
            model.venueId = this.state.venueId;
        }

        if(!this.state.isEdit){
            return LocationActions.save(model);
        } else {
            return LocationActions.update(this.state.locationId, model);
        }
    },

    onLocationChange: function() {
        const details = LocationStore.getById(this.state.locationId);
        if (details !== undefined) {
            this.setState({details});
        }
    },

    onLocationTypeChange: function() {
        const types = LocationTypeStore.getAll();
        if (!!types) {
            this.setState({types});
        }
    },

    onLocationStatusChange: function() {
        const statuses = LocationStatusStore.getAll();
        if (!!statuses) {
            this.setState({statuses});
        }
    },

    onCountriesChange: function () {
        const countries = CountryStore.getAll();
        if (!!countries) {
            this.setState({countries});
        }
    }

});

export default Location;
